import React, { useEffect } from 'react';
import Navigation from './Navigation';
import FabricScaleSection from './FabricScaleSection';
import Footer from './Footer';
import PageSEO from './PageSEO';

const MaterialsPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <PageSEO path="/materials" />
      <Navigation />
      <main style={{ paddingTop: '60px' }}>
        <FabricScaleSection />
      </main>
      <Footer />
    </>
  );
};

export default MaterialsPage;
